import React from 'react'

import { useLocation, Link } from "react-router-dom";

const KiosksScreenCopy = () => {

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    let kioskId = params.get('id');

    return (
        <>
            <div className="container-fluid">

                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h1>Kiosks Screen</h1>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/kiosks-management">Kiosks</Link></li>
                                    <li className="breadcrumb-item">{kioskId}</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
                <div className="row clearfix">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="body">
                                <div className="nk-sales-ck large pt-4" style={{ height: "100%" }}>
                                    <iframe
                                        key={"19"}
                                        src={"http://192.168.1.82:8000/#!action=stream&udid=192.168.1.244%3A5555&ro=false&player=broadway&ws=ws%3A%2F%2F192.168.1.82%3A8000%2F%3Faction%3Dproxy-adb%26remote%3Dtcp%253A8886%26udid%3D192.168.1.244%253A5555"}
                                        title={`Iframe FUM`}
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            border: "none"
                                        }}
                                    ></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default KiosksScreenCopy